export default {
	isRight: false,
};
